//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {rewardDetail,rewardList} from "@/model/distribution/reward";
import zdialog from "@/components/toast/Zdialog.vue";
import tableGrid from '@/components/tableGrid'

  export default {
    data() {
      return {
        Odetail:{},
        settling:'0', //0 奖励明细  1待生效
        page:1,
        list:[],
        isTrue:false, //是否加载中
        data:{
          str:'你每成功推荐一人购买产品，即可获得奖励金。产品的提现时间规则如下：',
          tabledata:{
            title:['产品','提现时间'],
            cont:[
              ['牙齿清洁保障计划','好友购买31天后未退款，可以提现奖金'],
            ]
          },
        },
        helpInfo:false,
      }
    },
    components: {
      zdialog,
      tableGrid,
    },
    created () {
      this.getDetail();
      this.getList(this.settling);
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
      this.STATISTICS('load','sybao_ins_distri_bonus_detail_page')
    },
    beforeDestroy(){
        window.removeEventListener('scroll', this.handleScroll);   //  离开页面清除（移除）滚轮滚动事件
    },
    methods: {
      // 帮助弹框
      tipsShow(){
          this.helpInfo = true;
          this.$refs.zdialog.showoast()
      },
      // 提现详情
      getDetail() {
        rewardDetail().then(res =>{
          this.Odetail = res
        })
      },
      // 点击提现
      Withdrawal(status){
        this.STATISTICS('click','sybao_ins_bonus_detail_withdraw_click')
        if(status == 0){
          // 跳转提现页面。
          this.$router.push({
            path: "/withDrawal",
            query:{
                flag : 'postdisable'
            }
          })
        }else if(status == 1){
          this.$toast("您目前没有可提现的奖金哦");
        }else if(status == 2){
          this.$toast("0点-3点为系统结算时间，暂不支持提现。请稍后重试");
        }else if(status == 3){
          this.helpInfo = false;
          this.$alert({
            msg:'您的账户疑似有违规行为，已被冻结，暂时不可提现。<br/>如有疑问，请致电客服17310389137申诉。',
            onConfirm:()=>{
              console.log("确定")
            }
          })
        }
      },
      // 获取奖励列表 
      getList(type){
        if(this.page == 0 || this.isTrue ){ //无数据或加载中
          return false;
        }
        this.isTrue = true;
        this.settling = type;
        rewardList(this.settling,this.page).then(res =>{
          console.log(res)
          let data = [];
          res.next ? data = res.data : data = res;
          if(data.length){
            data.forEach((item , index) =>{
              item.show = false
            })
          }
          if(this.page == 1){
            // document.getElementById('list_tab').scrollIntoView()
            this.list = data
          }else{
            this.list = this.list.concat(data);
          }
          this.page = res.next || 0;
          
          
        }).catch(err => {
          this.$toast(err.message)
        }).finally(all => {
          this.isTrue = false;
        })
      },
      // 展示奖励列表详情
      detailShow(index){
        this.list[index].show = !this.list[index].show
        this.STATISTICS('click','sybao_ins_bouns_detail_item_click')
      },
      // 滚动加载
      handleScroll(){
        let scrollHand = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        let bodyHe = document.getElementById("reward").clientHeight;
        let client = document.body.clientHeight;
        if(bodyHe - client - scrollHand < 10){
          this.getList(this.settling);
        }
      },
    },
  }
